var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-grid-cell-link"},[_c('el-dropdown',[_c('div',{staticClass:"text",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.params.value))]),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_vm._v("查看型号详情")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }